import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'demical2'
})
export class Demical2Pipe implements PipeTransform {
  constructor(
    private decimalPipe: DecimalPipe,
  ) {
  }

  transform(value: any, digitsInfo?: string, locale?: string): string | null {
    let result;
    result = this.decimalPipe.transform(value, digitsInfo, locale);

    // …do something with your result

    return result;
  }
} 
